import { writable } from "svelte/store";

let ExpenseStore = writable({
	data: {},
	loading: false,
	empty: true,
});

export default ExpenseStore;
